import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import axios from 'axios'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Sidebar from '../sidebar'
import NavLogo1 from '../../StudentRegristrationDesign/blockImage.jpg'
import { MDBDataTable } from 'mdbreact'
import { Col, Row } from 'react-bootstrap'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { toast } from 'react-toastify'
import { CheckBox } from '@mui/icons-material'
import NavLogo from '../NavLogo'
import {
  ImagePath,
  MemberAdminApprovalApi,
  MemberAdminViewApi,
  MemberApprovalApi,
} from '../../ApiFile'
import MobileNavbarAdmin from './MobileNavbarAdmin'

export default function ApplicationApprovalPending() {
  const [rows, setRows] = useState([])
  const [open, setOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState([])
  let flag = Number(sessionStorage.getItem('flag'))


 const fetchData = () => {
  axios
    .get(MemberApprovalApi)
    .then((response) => {
      const filteredRows = response.data
        .filter((row) => row.regform_approval === '0'  || row.regform_approval === '1') // ✅ only pending data
        .map((row, index) => ({
          ...row,
          Name: row.name,
          PayAmount: row.pay_amount,
        }))

      setRows(filteredRows)
    })
    .catch((error) => {
      // console.error(error);
    })
}

  useEffect(() => {
    fetchData()
  }, [])

  const handleViewClick = (row) => {
    // setSelectedRow(row || {})
    setOpen(true)

    axios
      .get(`${MemberAdminViewApi}/${row.reg_id}`)
      .then((response) => {
        setSelectedRow(response.data)
      })
      .catch((error) => {
        // console.error(error);
      })
  }


  const data = {
    columns: [
      { label: 'Reg_ID', field: 'reg_id' },
      { label: 'Name', field: 'Name', width: 150 },
      {
        label: 'View',
        field: 'View',
        render: (row) => (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleViewClick(row)}
            style={{ fontSize: '12px' }}
          >
            <span className="me-1">View </span>{' '}
            <i class="fa-regular fa-eye"></i>
          </Button>
        ),
      },
      {
        label: 'Status',
        field: 'Status',
        render: (row) => {
          if (row.regform_approval === '0') {
            return (
              <Button
                variant="contained"
                style={{
                  backgroundColor: 'orange',
                  color: 'white',
                  fontSize: '12px',
                }}
              >
                <span className="me-1">Pending</span>{' '}
                <i class="fas fa-spinner"></i>
              </Button>
            )
          } 
        },
      },
    ],
    rows: rows.map((row) => ({
      ...row,
      View: (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleViewClick(row)}
          style={{ fontSize: '12px' }}
        >
          <span className="me-1">View</span> <i class="fa-regular fa-eye"></i>
        </Button>
      ),
      Status:
        row.regform_approval === '0' ? (
          <>
            {(flag == 2) && (
              <Button
                variant="contained"
                color="primary"
                style={{
                  backgroundColor: 'orange',
                  color: 'white',
                  fontSize: '12px',
                  cursor:'not-allowed',
                }}
              >
                <span className="me-1">Pending</span>{' '}
                <i class="fas fa-spinner"></i>
              </Button>
            )}
          </>
        ) : row.regform_approval === '1' ? (
          <Button
            variant="contained"
            style={{
              backgroundColor: 'green',
              color: 'white',
              fontSize: '12px',
            }}
            disabled
          >
            <span className="me-1">Approved</span> <i class="fas fa-check"></i>
          </Button>
        ) : (
          <Button
            variant="contained"
            style={{ backgroundColor: 'red', color: 'white', fontSize: '12px' }}
            disabled
          >
            <span className="me-1">Rejected</span> <i class="fas fa-times"></i>
          </Button>
        ),
    })),
  }

  return (
    <>
      <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <NavLogo />

        <div className="d-block d-md-none">
          <MobileNavbarAdmin />
        </div>


        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Application Pending List
            </h5>
          </div>

        <Row
          className="m-0 p-0 px-md-3 py-1 pb-5 mb-5 mt-4 w-100"
          style={{ display: 'flex' }}
        >
          <Col
            className="m-0 p-0 px-3 py-3 rounded shadow"
            style={{ background: 'white' }}
          >
            <div style={{ overflowY: 'auto' }}>
              <div style={{ overflowX: 'auto' }}>
                <MDBDataTable
                  striped
                  className="custom-datatable text-center"
                  bordered
                  hover
                  small
                  data={data}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="status-modal-title"
          aria-describedby="status-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '700px',
              maxHeight: '90vh',
              overflow: 'scroll',
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                overflowY: 'auto',
                overflowY: 'scroll',
                p: 4,
                flex: 1,
              }}
            >
              <Typography
                id="modal-modal-description"
                style={{ lineHeight: '18px' }}
              >
                <div className="block-header">
                  <h2
                    className="mb-3"
                    style={{
                      color: 'maroon',
                      borderBottom: '2px solid maroon',
                    }}
                  >
                    Application Form eeee
                  </h2>
                </div>
                <Row>
                  <Col>
                    {' '}
                    <b>Name</b>:
                  </Col>
                  <Col> {selectedRow.name} </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <b>Address</b>:
                  </Col>
                  <Col>{selectedRow.address}</Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <b>Mobile No.</b>:
                  </Col>
                  <Col>{selectedRow.mob_no} </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <b>Amount Paid Rs</b>:
                  </Col>
                  <Col>{selectedRow.payment_amount}</Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <b>Pay Mode</b>:
                  </Col>
                  <Col>{selectedRow.pay_mode}</Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <b>Transaction Id</b>:{' '}
                  </Col>
                  <Col>{selectedRow.taxId} </Col>
                </Row>
                <br />
                <Row style={{ display: 'flex' }}>
                  <Col>
                    <b>Transaction Image</b>:{' '}
                  </Col>
                  <Row>
                    <Col md={3}></Col>
                    <Col className=" mt-2 text-center" md={6}>
                      <img
                        src={`${ImagePath}/${selectedRow.tax_image}`}
                        className="acceptable rounded shadow border-0"
                        alt=""
                        style={{
                          height: '16rem',
                          width: '15rem',
                          border: '1px solid grey',
                        }}
                      />
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                </Row>
              </Typography>
            </Box>
            <Box
              sx={{
                p: 2,
                borderTop: '1px solid #ccc',
                textAlign: 'right',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>

      </div>
      </div>
      </div>
    </>
  )
}
